<template>
  <div class="page-template add-page">
    <div class="page-title">{{ title }}
    </div>
    <div class="btn-box">
      <el-button @click="refresh" icon="el-icon-refresh">刷新</el-button>
      <el-button @click="beBack" icon="el-icon-arrow-left">返回</el-button>
      <el-button @click="checkGoods" icon="el-icon-shopping-cart-2">选择商品</el-button>
      <el-button @click="audit" icon="el-icon-edit-outline" :disabled="formModel.reviewerStatus == 10">审核</el-button>
      <el-button @click="submitAuth" icon="el-icon-collection" :disabled="formModel.reviewerStatus == 10">保存</el-button>
    </div>
    <div></div>
    <list-operation-form ref="listOperationForm" :formOptions="listFormOptions"></list-operation-form>
    <list-operation ref="listOperation" :tableOptions="listColumns"></list-operation>
    <el-dialog title="商品列表" :visible.sync="listShow" width="1200px" height="800"
               :close-on-click-modal="false">
      <good-list @rowCheck="rowCheck" :isSelect="goodListSelect" :otherParam="otherParam"
                 :tableOptions="tableOptions" @selectSubmit="rowsSelectSubmit"></good-list>
    </el-dialog>
  </div>
</template>
<script>
  //商品列表组件
  import goodList from '@/components/business/goodList';
  //添加要货单组件
  import listOperation from '@/components/template/listOperation';
  //要货单搜索组件
  import listOperationForm from '@/components/template/listOperationForm';
  import api from '@/config/api';

  export default {
    components: {
      listOperation,
      goodList,
      listOperationForm
    },
    data() {
      return {
        goodListSelect: false,
        loading: false,
        title: '',
        listShow: false,
        goodList: [],
        formModel: {},
        dialogShow: false,
        otherParam: {},
        // 添加头部字段
        //条件
        listFormOptions: {
          disabled: false,
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            }
          },
          labelWidth: '130px',
          columns:
            [{
              label: '业务单号',
              type: 'select',
              prop: 'orderNo',
              url: api.warehouse.batch,
              param: {reviewerStatus: 20},
              data: [],
              labelKey: 'orderNo',
              uniqueKey: 'orderNo',
              disabled: true,
              span: 12,
            }, {
              label: '主键id',
              type: 'input',
              prop: 'id',
              hidden: true
            }, {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              rule: [
                {required: true, message: "请选择门店", trigger: "blur"},
              ],
              data: [],
              span: 12,
              url: api.system.seStore,
            }, {
              label: '原因',
              type: 'select',
              prop: 'type',
              span: 12,
              data: this.$utils.getCacheStatus('wgCleanOrder.type')
            }, {
              label: '备注',
              type: 'input',
              prop: 'remarks',
              span: 12,
            }]
        },
        // 添加表格字段
        listColumns: {
          disabled: false,
          indexShow: true,//是否显示索引
          summaryColumns: ['goodsNum', 'goodsBoxNum', 'cleanPrice'],
          columns: [
            {label: '序号', type: 'index', width: 100, prop: 'idx'},
            {label: '操作', type: 'operation', width: 100, prop: 'operation'},
            {
              label: '条码',
              prop: 'barCode',
              type: 'more',
              callback: this.getInfo,
              width: '190'
            },
            {
              label: '自编码',
              prop: 'artNo',
              width: '130'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '100'
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '100'
            },
            {
              label: '进货规格',
              prop: 'specs',
              width: '100'
            },
            {
              label: '日清数量',
              prop: 'goodsNum',
              width: '100',
              type: 'inputNumber',
              change: this.numChange
            },
            {
              label: '日清箱数',
              prop: 'goodsBoxNum',
              width: '100',
              type: 'inputNumber',
              change: this.numBoxChange
            },
            {
              label: '单价',
              prop: 'purchasePrice',
              width: '100'
            },
            {
              label: '系统库存',
              width: '100',
              prop: 'inventoryNum',
            },
            {
              label: '金额',
              prop: 'cleanPrice',
              width: '100'
            },
            {
              label: '零售价',
              prop: 'retailPrice',
              width: '100'
            },
            {
              label: '备注',
              prop: 'remarks',
              width: '90',
            },
          ],
          url: api.weigh.cleanOrder
        },
        // 表格信息配置
        tableOptions: {
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              width: '100',
              align: 'center'
            },
            {
              label: "品名",
              prop: "goodsName",
              width: "200",
              align: "center"
            },
            {
              label: "自编码",
              prop: "artNo",
              width: "100",
              align: "center"
            },
          ],
          url: api.archives.goodsInfoIncludeSpecs
        },
        checkIndex: ''
      }
    },
    created() {
      this.title = document.title + (this.$route.query.id ? '编辑' : '新增');
      if (this.$route.query.id) {
        this.getDetail();
      }
    },
    methods: {
      getDetail() {
        this.loading = true;
        this.$axios
          .fetchGet(api.weigh.cleanOrder + '?id=' + this.$route.query.id, {})
          .then(data => {
            this.loading = false;
            if (data.code == 200 && data.data) {
              this.formModel = data.data;
              if (this.formModel.reviewerStatus == 10) {
                this.listFormOptions.disabled = true;
                this.listColumns.disabled = true;
              }
              this.$nextTick(() => {
                //为头部表单赋值
                this.$refs.listOperationForm.formModel = data.data;
                //为表格赋值
                this.$refs['listOperation'].addMoreRow(data.data.wgCleanOrderGoodsMapList, 0);
              });
            } else if (data.code == 200 && !data.data) {
              this.$message({message: '获取数据出错！', type: 'error'});
              this.$router.push({path: '/warehouse/inventory/goods'});
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          })
          .catch(err => {
            console.log(err);
            this.$message({message: '请求失败！', type: 'error'});
            this.loading = false;
          });
      },
      checkGoods() {
        this.listShow = true;
        this.goodListSelect = true;
      },
      rowsSelectSubmit(rows) {
        this.listShow = false;
        rows.forEach(e => {
          e.goodsNum = e.inventoryNum;
          e.goodsBoxNum = e.inventoryNum;
          e.cleanPrice = parseFloat(e.purchasePrice * e.goodsNum).toFixed(2);
        });
        this.$refs['listOperation'].addMoreRow(rows, 0);
      },
      numChange(row, index) {
        row.goodsBoxNum = row.goodsNum;
        if (row.purchasePrice) {
          row.cleanPrice = parseFloat(row.purchasePrice * row.goodsNum).toFixed(2);
        }
        this.$refs['listOperation'].setColumnData(row, index);
      },
      numBoxChange(row, index) {
        row.goodsNum = row.goodsBoxNum;
        if (row.purchasePrice) {
          row.cleanPrice = parseFloat(row.purchasePrice * row.goodsNum).toFixed(2);
        }
        this.$refs['listOperation'].setColumnData(row, index);
      },
      //选择某行数据
      rowCheck(row) {
        this.listShow = false;
        row.goodsNum = row.inventoryNum;
        row.goodsBoxNum = row.inventoryNum;
        row.cleanPrice = parseFloat(row.purchasePrice * row.goodsNum).toFixed(2);
        this.$refs['listOperation'].setColumnData(row, this.checkIndex);
      },
      //提交数据
      submitAuth() {
        this.$axios
          .fetchPost(api.weigh.cleanOrder, this.getParams())
          .then(data => {
            this.loading = false;
            if (data.code == 200) {
              this.$notify({
                type: "success",
                title: '保存操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '日清单操作成功', type: 'success'});
              this.$refs.listOperationForm.formModel = data.data;
              this.$set(this.$refs.listOperationForm.formModel, 'reviewerStatus', 20);
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          }).catch(err => {
          this.$notify({
            type: "error",
            title: '保存操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({message: '请求失败！', type: 'error'});
          this.loading = false;
        });
      },
      audit() {
        this.$axios
          .fetchPost(api.weigh.cleanOrder + '/audit', this.getParams())
          .then(data => {
            this.loading = false;
            if (data.code == 200) {
              this.$notify({
                type: "success",
                title: '审核操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '审核成功', type: 'success'});
              this.$refs.listOperationForm.formModel = data.data;
              this.$set(this.$refs.listOperationForm.formModel, 'reviewerStatus', data.data.reviewerStatus);
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          }).catch(err => {
          this.$notify({
            type: "error",
            title: '审核操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({message: '请求失败！', type: 'error'});
          this.loading = false;
        });
      },
      getParams() {
        let tableList = this.$refs['listOperation'].getTabelData();
        tableList.map(item => {
          if (item.goodsId == null) {
            item.goodsId = item.id;
          }
        });
        let totalParam = this.$refs['listOperation'].getSumData();
        let headParam = this.$refs.listOperationForm.getFormModel()
        totalParam.orderPrice = totalParam.cleanPrice;
        return {
          ...{wgCleanOrderGoodsMapList: tableList}, ...totalParam, ...headParam
        }
      },
      //获取某行数据填充
      getInfo(rowData, index) {
        this.listShow = true;
        this.goodListSelect = false;
        this.checkIndex = index;
      },
      //返回按钮事件
      beBack() {
        this.$router.go(-1);
      },
      refresh() {
        this.$router.go(0);
      },
    }

  }
</script>



// WEBPACK FOOTER //
// src/page/weigh/speciality/OrderAdd.vue